export const DEFAULT_REPRESENTATIVE_FILTERS = {
  status: { id: "TODOS", value: "TODOS", label: "Todos" },
  region: null,
  grupoEconomico: null,
  razaoSocial: null,
  cnpj: "",
  search: "",
};

export function mergeProductsByCodigo(existing = [], incoming = []) {
  const map = new Map();
  existing.forEach((p) => {
    if (p?.Codigo != null) map.set(p.Codigo, p);
  });
  incoming.forEach((p) => {
    if (p?.Codigo != null) map.set(p.Codigo, p);
  });
  return Array.from(map.values());
}

export function selectedProductsNeedGradeEnrichment(products = []) {
  if (!products.length) return false;
  return products.some((p) => {
    if (p?.Codigo == null) return false;
    const hasGradeInfo =
      String(p.SubgradeVenda ?? p.subgradeVenda ?? "").trim() ||
      String(p.CorGrade ?? p.corGrade ?? "").trim() ||
      String(p.Marca ?? p.marca ?? "").trim();
    return !hasGradeInfo;
  });
}

export function enrichSelectedProductsWithListItems(selected = [], listItems = []) {
  const byCodigo = new Map(
    listItems.map((item) => [String(item.Codigo), item]),
  );
  return selected.map((product) => {
    const full = byCodigo.get(String(product.Codigo));
    if (!full) return product;
    return {
      ...full,
      FotoPrincipal: full.Foto ?? full.FotoPrincipal ?? product.FotoPrincipal,
      foto: full.Foto ?? full.foto ?? product.foto,
      Nome: full.Nome ?? product.Nome ?? product.nome,
      nome: full.Nome ?? product.nome ?? product.Nome,
      Desconto: product.Desconto ?? product.desconto ?? 0,
    };
  });
}

export function hasUnsavedWizardWork({
  currentStep,
  formData,
  selectedProducts,
  representatives,
}) {
  return (
    currentStep > 0 ||
    !!formData?.name?.trim() ||
    !!formData?.description?.trim() ||
    (formData?.paymentConditions?.length ?? 0) > 0 ||
    (formData?.priceTables?.length ?? 0) > 0 ||
    (selectedProducts?.length ?? 0) > 0 ||
    (representatives?.length ?? 0) > 0
  );
}

export const WIZARD_LEAVE_CONFIRM_MESSAGE =
  "Existem alterações não salvas. Deseja sair e descartar o progresso?";

function hasValidPaymentConditions(formData) {
  const list = formData?.paymentConditions;
  if (!Array.isArray(list) || list.length === 0) return false;

  return list.every((c) => {
    if (!c?.IdCondicaoPagamento) return false;
    const pct = c.PercentualDesconto;
    if (pct == null || pct === "") return false;
    const n = Number(pct);
    return !Number.isNaN(n) && n >= 0;
  });
}

function hasPayments(formData) {
  return hasValidPaymentConditions(formData);
}

function hasPriceTables(formData) {
  return (
    (formData.priceTables?.length ?? 0) > 0 ||
    !!formData.priceTable?.CodTabelaPreco
  );
}

export function isStepReady(
  step,
  { formData, selectedProducts, representatives },
) {
  if (step === 0) {
    return (
      !!formData.brand?.value &&
      !!(
        (formData.initialDate && formData.finalDate) ||
        formData.untilSoldOut
      ) &&
      !!formData.name?.trim()
    );
  }

  if (step === 1) {
    return (
      hasPayments(formData) &&
      hasPriceTables(formData) &&
      !!(formData.byLine || formData.byOrder)
    );
  }

  if (step === 2) {
    return (selectedProducts?.length ?? 0) > 0;
  }

  if (step === 3) {
    return (
      (representatives?.length ?? 0) > 0 &&
      hasValidPaymentConditions(formData)
    );
  }

  return false;
}

export function getStepValidationHint(step, state) {
  if (isStepReady(step, state)) return null;

  if (step === 0) {
    const missing = [];
    if (!state.formData?.brand?.value) missing.push("marca");
    if (
      !state.formData?.untilSoldOut &&
      (!state.formData?.initialDate || !state.formData?.finalDate)
    ) {
      missing.push("período de vigência");
    }
    if (!state.formData?.name?.trim()) missing.push("nome da vitrine");
    return `Preencha: ${missing.join(", ")}.`;
  }

  if (step === 1) {
    const missing = [];
    if (!hasPayments(state.formData)) {
      missing.push("ao menos uma condição de pagamento com desconto");
    }
    if (!hasPriceTables(state.formData)) missing.push("tabela de preço");
    if (!state.formData?.byLine && !state.formData?.byOrder) {
      missing.push("regra por linha ou por pedido");
    }
    return `Preencha: ${missing.join(", ")}.`;
  }

  if (step === 2) {
    return "Adicione ao menos um produto à vitrine.";
  }

  if (step === 3) {
    const missing = [];
    if (!hasValidPaymentConditions(state.formData)) {
      missing.push("ao menos uma condição de pagamento com desconto");
    }
    if ((state.representatives?.length ?? 0) === 0) {
      missing.push("representante");
    }
    if (missing.length === 0) return null;
    return `Preencha: ${missing.join(", ")}.`;
  }

  return null;
}
